import { render, staticRenderFns } from "./DagbladetForm.vue?vue&type=template&id=3502ab0e&scoped=true&"
import script from "./DagbladetForm.vue?vue&type=script&lang=js&"
export * from "./DagbladetForm.vue?vue&type=script&lang=js&"
import style0 from "./DagbladetForm.vue?vue&type=style&index=0&id=3502ab0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3502ab0e",
  null
  
)

export default component.exports